module.exports = __webpack_public_path__ + "static/media/jsfwcaScreenshot.7008feb0.jpg";